<style lang="scss">
  @use "../../assets/css/design-system/colors";
  div {
    display: contents;
    @include colors.utility_classes();

    svg {
      @keyframes pulseDot {
        0%,
        100% {
          transform: scale(1);
          opacity: var(--base-opacity);
        }
        50% {
          transform: scale(var(--dot-scale));
          opacity: calc(var(--base-opacity) * 1.5);
        }
      }
      circle {
        fill: currentColor;
        animation: pulseDot var(--animation-duration) infinite ease-in-out;
        transform-origin: center;
        transform-box: fill-box;
      }
    }
  }
</style>

<script>
  let cls = "";
  export { cls as class };
  export let size = "medium";

  // Match up with Icon.svelte
  const px = {
    small: 12,
    medium: 16,
    large: 20,
    xl: 34,
  };

  $: dx = px[size] || 16;

  const dotCounts = {
    small: 3,
    medium: 3,
    large: 4,
    xl: 4,
  };

  let dotSize = 2;
  let dotSpacing = 2.5;
  let animationDuration = 1.2;
  let dotScale = 1.5;
  let baseOpacity = 0.5;

  const dots = Array.from({ length: dotCounts[size] || 4 }, (_, i) => ({
    cx: dotSize + i * (dotSize * 2 + dotSpacing) + 1,
    delay: i * 0.2,
  }));

  const svgWidth = dots.at(-1).cx + dotSize + 2;
</script>

<div class={cls}>
  <svg
    class="loading-dots"
    width={dx}
    height={dx}
    viewBox="0 0 {svgWidth} {dotSize * 2 + 2}"
    fill="none"
  >
    {#each dots as { cx, delay }}
      <circle
        class={cls}
        {cx}
        cy={dotSize + 1}
        r={dotSize}
        style="animation-delay: {delay}s; --dot-scale: {dotScale}; --base-opacity: {baseOpacity}; --animation-duration: {animationDuration}s;"
      ></circle>
    {/each}
  </svg>
</div>
